import {CountdownTimer} from '@/components/commons/header/header-banner/components/countdown-timer/CountdownTimer'
import {formatDateWithUTC} from '@/dayjs'
import {useMe} from '@/features/authentication/queries/useMe'
import {GuestTypeV3} from '@/features/authentication/types'
import {useTranslation} from 'react-i18next'
import {StyledBannerRoot, StyledCountdown, StyledFor} from './style'

export const CashbackBanner = () => {
    const {t} = useTranslation()
    const {data} = useMe()
    const user = data as GuestTypeV3

    const ultimateOffer = user?.typeAttributes?.ultimateOffer
    const cashBackOffer = user?.typeAttributes?.cashbackOffer

    const offerEndDateLocal =
        (cashBackOffer?.endDate && formatDateWithUTC(cashBackOffer.endDate, 'YYYY-MM-DD HH:mm:ss')) ||
        (ultimateOffer?.endDate && formatDateWithUTC(ultimateOffer.endDate, 'YYYY-MM-DD HH:mm:ss'))

    const isCashbackOfferAvailable = cashBackOffer?.isAvailableCashbackOffer

    if (!isCashbackOfferAvailable || !offerEndDateLocal) return

    return (
        <StyledBannerRoot>
            <StyledCountdown>
                <StyledFor>{t('common:for')}</StyledFor>
                <CountdownTimer targetDate={offerEndDateLocal} showDays={false} />
                <div>{t('common:only')}:</div>
            </StyledCountdown>
            <h4>{t('promotion_banners:explanation_banner_cashback:title')}</h4>
            <p>{t('promotion_banners:explanation_banner_cashback:description')}</p>
        </StyledBannerRoot>
    )
}
